export const RESET_BASE_PRODUCT = 'RESET_BASE_PRODUCT';
export const REDUCER_RESET_BASE_PRODUCT = 'REDUCER_RESET_BASE_PRODUCT';

export const resetBaseProduct = () => ({
  type: REDUCER_RESET_BASE_PRODUCT,
});
